import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import { Droppable } from 'react-beautiful-dnd'
import BlueLine from 'ui/v2/BlueLine'
import ButtonOutline from 'ui/v2/ButtonOutline'
import Text from 'ui/v2/Text'
import { CONSTANTS_FORM_BUILDER } from 'utils/FormBuilder/ConstantsFormBuilder'

function DroppableRow({ sectionId, rowId, isFirst }) {
  const [newRowId, setNewRowId] = React.useState(null)

  const droppableIdPrefix = isFirst ? 'firstblueline' : 'blueline'
  const {
    selectedItem,
    setSelectedItem,
    addRowInBetween,
    questionsArray,
    getSection,
    getPage,
    reorderSourceRow,
  } = React.useContext(FormBuilderContext)

  React.useEffect(() => {
    // It's important to clear the newRowId if the selected item changes.
    // Otherwise, the blue line would sometimes be active along with the add question button of the same id.
    if (selectedItem?.id !== newRowId) {
      setNewRowId(null)
    }
  }, [newRowId, selectedItem])

  const activeBlueLine = React.useMemo(
    () => newRowId === selectedItem?.id,
    [newRowId, selectedItem]
  )

  const handleClick = React.useCallback(() => {
    const newRowId = addRowInBetween(sectionId, rowId, isFirst)
    setNewRowId(`${newRowId}_6`)
    setSelectedItem({
      id: `${newRowId}_6`,
      type: CONSTANTS_FORM_BUILDER.SELECTION_TYPE.QUESTION_ADD,
    })
  }, [rowId, sectionId, addRowInBetween, setSelectedItem, isFirst])

  const isDropDisabled = React.useCallback(() => {
    if (!reorderSourceRow) return false

    const targetQuestion = questionsArray.find((q) => q.row === rowId)
    if (!targetQuestion) return false

    const targetSection = getSection(targetQuestion.section)
    if (!targetSection) return false

    const targetPage = getPage(targetSection.page)
    const targetIsRepeatSection = Boolean(targetPage?.repeat_section)

    const sourceQuestion = questionsArray.find(
      (q) => q.row === reorderSourceRow
    )
    if (!sourceQuestion) return false

    const sourceSection = getSection(sourceQuestion.section)
    if (!sourceSection) return false

    const sourcePage = getPage(sourceSection.page)
    const sourceIsRepeatSection = Boolean(sourcePage?.repeat_section)

    return targetIsRepeatSection !== sourceIsRepeatSection
  }, [reorderSourceRow, rowId, questionsArray, getSection, getPage])

  return (
    <Droppable
      isCombineEnabled
      direction="horizontal"
      droppableId={`${droppableIdPrefix}_${sectionId}_${rowId}`}
      isDropDisabled={isDropDisabled()}
      type="TASK"
    >
      {(provided, snapshot) => {
        const active = activeBlueLine || snapshot.isDraggingOver
        return (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            onClick={handleClick}
          >
            <BlueLine visibleOnHover active={active} />
            {active ? (
              <div className="pb-1">
                <ButtonOutline isHighlighted>
                  <Text muted xlarge>
                    +
                  </Text>
                </ButtonOutline>
              </div>
            ) : null}
            {/* </Space> */}
            <div style={{ maxHeight: 0 }}>{provided.placeholder}</div>
          </div>
        )
      }}
    </Droppable>
  )
}

export default DroppableRow
